import React, { Children } from "react"
import Layout from "./Layout"
import style from "./Page.module.scss"

export default ({ children }) => {
  return (
    <Layout>
      <section className={style.container}>
        {children}
      </section>
    </Layout>
  )
}
